'use client';

import {
  SelectAccountAgeFeature,
  SelectAccountFeature,
} from '@features/items-withdrawal';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { BottomSheetUi } from '@/shared/ui/mobile/bottom-sheet';
import { useStore } from '@/store/context';

import styles from './styles.module.scss';

export const CreateTradeMobileWidget = observer(() => {
  const withdrawalStore = useStore().withdrawal;

  return (
    <BottomSheetUi
      handleClose={() => withdrawalStore?.setSelectedTrade(null)}
      isOpen={!!withdrawalStore?.createTradeOpened}
      className={styles.modal}>
      {withdrawalStore?.selectedAccountAge ? (
        <SelectAccountFeature />
      ) : (
        <SelectAccountAgeFeature />
      )}
    </BottomSheetUi>
  );
});
